export interface GoogleMapsLatLng {
  lat: number;
  lng: number;
}

export const STARTING_LOCATION = 'Claremore';

export const SERVICE_AREAS_PRIORITY = new Map<string, GoogleMapsLatLng>([
  [
    'Broken Arrow',
    { lat: 36.060_011_106_296_315, lng: -95.797_589_199_666_26 },
  ],
  ['Catoosa', { lat: 36.188_864_444_724_08, lng: -95.745_330_206_370_68 }],
  ['Claremore', { lat: 36.312_603_499_017_58, lng: -95.618_686_688_076_41 }],
  ['Owasso', { lat: 36.269_303_029_476_42, lng: -95.852_945_290_968_76 }],
  [
    'Rogers County',
    { lat: 36.388_670_788_455_04, lng: -95.645_899_980_797_08 },
  ],
  ['Tulsa', { lat: 36.153_851_896_310_79, lng: -95.997_495_387_292_59 }],
  ['Verdigris', { lat: 36.236_375_834_614_24, lng: -95.687_443_856_423_68 }],
  ['Inola', { lat: 36.151_857_694_799_58, lng: -95.509_130_111_348_44 }],
]);

export const SERVICE_AREAS_OTHER = new Map<string, GoogleMapsLatLng>([
  ['Adair', { lat: 36.436_914_602_715_73, lng: -95.269_922_359_009_87 }],
  ['Bixby', { lat: 35.941_201_874_479_46, lng: -95.883_264_676_966_36 }],
  ['Chelsea', { lat: 36.536_015_496_902_955, lng: -95.431_953_512_268_31 }],
  ['Collinsville', { lat: 36.364_504_937_623_22, lng: -95.838_611_485_979_74 }],
  ['Coweta', { lat: 35.952_700_003_696_92, lng: -95.653_691_499_284_22 }],
  ['Foyil', { lat: 36.435_062_630_164_815, lng: -95.519_402_418_081_8 }],
  [
    'Grand Lake Towne',
    { lat: 36.504_288_136_832_86, lng: -94.022_977_928_384_62 },
  ],
  ['Jenks', { lat: 36.022_947_134_669_24, lng: -95.968_656_589_115_84 }],
  ['Oologah', { lat: 36.447_172_742_018_154, lng: -95.708_409_825_460_17 }],
  ['Pryor', { lat: 36.308_541_321_602_59, lng: -95.317_471_076_851_18 }],
  ['Selina', { lat: 36.292_972_977_239_12, lng: -95.153_650_206_147_74 }],
  ['Vinita', { lat: 36.638_470_313_933_36, lng: -95.154_045_207_518_72 }],
]);

export const SERVICE_AREAS = new Map<string, GoogleMapsLatLng>([
  ...SERVICE_AREAS_PRIORITY,
  ...SERVICE_AREAS_OTHER,
]);

export function generateAreaServedSchema(): any[] {
  const towns = Array.from(SERVICE_AREAS.entries()).map(([town, coords]) => ({
    '@type': 'Place',
    name: town,
    geo: {
      '@type': 'GeoCoordinates',
      latitude: coords.lat,
      longitude: coords.lng,
    },
    address: {
      '@type': 'PostalAddress',
      addressLocality: town,
      addressRegion: 'OK',
      addressCountry: 'US',
    },
  }));

  return [{ '@type': 'Place', name: 'Northeast Oklahoma, OK' }, ...towns];
}
